import {BlockBuilder} from '../../classes/blockBuilder';
import {BlockType} from '../../classes/blockType';

export const columns = new BlockType({
  name: 'columns',
  title: 'Columns',
  compatibility: ['mail'],
  component: () =>
    import(/* webpackChunkName: "TmlMailPage" */ './ColumnsBlock.vue'),
  builder: () =>
    BlockBuilder.create('columns')
      .property('backgroundColor', '#fff0')
      .property('borderRadius', '0px'),
});
